module.exports = __webpack_public_path__ + "static/media/ad0.14002771.png";